import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import BannerChevron from './assets/banner-chevron.svg';
import QmeePerson from './assets/qmee-person.svg';
import QmeeEdit from './assets/qmee-edit.svg';
import ContinuousProfiling from './assets/Continuous_Profiling.svg';
import BoostProfiling from './assets/Boost_Profiling.svg';
import EditPen from './assets/edit-pen.svg';
import classes from './ContinuousProfiler.qmee.module.scss';
import { useMoreSurveysBannerQuery_profileUrlRef$data } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';
import { ProgressBar } from 'components/atoms/ProgressBar/ProgressBar';
import { SURVEY_PROFILE } from 'components/pages/pages';

type Props = {
  data: useMoreSurveysBannerQuery_profileUrlRef$data;
  className: string;
  profilerTitle: string;
  hasEditIcon?: boolean;
  hasBannerChevron?: boolean;
  profilerSupportingText?: string;
  version: 'dashboard' | 'more' | 'earn';
};

export default function ContinuousProfiler({
  data,
  className,
  profilerTitle,
  hasEditIcon,
  hasBannerChevron = false,
  profilerSupportingText,
  version,
}: Props) {
  const percentageComplete = data.profileCompletionPercentage?.profileCompletionPercentage ?? 0;

  if (!data.endlessProfilerUrl && !data.demographicProfileUrl) {
    return null;
  }

  const href =
    version === 'more'
      ? SURVEY_PROFILE.path
      : data.endlessProfilerUrl && `${data.endlessProfilerUrl}&v2=true`;

  if (!href) {
    return null;
  }

  return (
    <Card className={clsx(classes.root, className)}>
      {version === 'dashboard' &&
        (percentageComplete <= 98 ? (
          <ContinuousProfiling className={classes.qmeeLgContinuousPersonTopRight} />
        ) : (
          <BoostProfiling className={classes.qmeeLgBoostPersonTopRight} />
        ))}
      <QmeePerson
        className={clsx(
          classes.qmeeMobPersonTopRight,
          version === 'dashboard' && classes.hideOnDesktop,
          version === 'more' && classes.hideOnEdit,
        )}
      />
      {hasEditIcon && (
        <QmeeEdit
          className={clsx(classes.qmeeEdit, version === 'dashboard' && classes.hideOnDesktop)}
        />
      )}
      <A href={href} className={classes.innerLink}>
        <div className={classes.userRow}>
          <Txt className={classes.userName}>{profilerTitle}</Txt>
          {hasEditIcon && (
            <Txt className={classes.editText}>
              Edit
              <EditPen className={classes.editIcon} />
            </Txt>
          )}
        </div>
        {version === 'dashboard' &&
          (percentageComplete <= 98 ? (
            <Txt className={classes.text}>Complete your profile for better survey completion.</Txt>
          ) : (
            <Txt className={classes.text}>Boost your profile for better survey conversions.</Txt>
          ))}
        <Txt
          className={clsx(classes.text, version === 'dashboard' && classes.hideIfNotMainProfiler)}
        >
          {profilerSupportingText}
        </Txt>
        <div
          className={clsx(
            classes.progressSection,
            version === 'dashboard' && classes.marginIfLargeDesktopVariant,
          )}
        >
          <ProgressBar
            style="linear"
            value={percentageComplete}
            max={100}
            className={classes.progressBar}
          />
          <div className={classes.percentage}>
            <span>{percentageComplete}%</span>
            {hasBannerChevron && <BannerChevron className={classes.chevron} />}
          </div>
        </div>
      </A>
    </Card>
  );
}
